export default class Environment {

    public static get isDev(): boolean {
        switch (Environment.environment()) {
            case 'production':
                return false;
            case 'development':
                return true;
            default:
                return false;
        }
    }

    public static get isPopina(): boolean {
        switch (Environment.applicationName()) {
            case "popina":
                return true;
            case "jalia":
                return false;
            default:
                return true
        }
    }

    public static environment(): string {
        return (process.env as any).REACT_APP_ENV;
    }

    public static applicationName(): string {
        return ((process.env as any).REACT_APP_APP_NAME !== undefined) ? (process.env as any).REACT_APP_APP_NAME : "jalia"
    }
}